import { render } from "./AddEventBS.vue?vue&type=template&id=4b4ef914"
import script from "./AddEventBS.vue?vue&type=script&lang=js"
export * from "./AddEventBS.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__